import { Injectable } from '@angular/core';
import { SessionInfo } from '../models/sessioninfo';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './configuration.service';
import { NewSwingRequest } from '../models/newSwingRequest';
import { Swing } from '../models/swing';
import { ShotData } from '../models/shotData';
import { Session } from '../models/session';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private configService:ConfigService, private http:HttpClient, private authenticationService:AuthenticationService) { 
    this.baseUrl = configService.getApiEndpoint();
  }

  baseUrl:string;

  async createSession(createSessionRequest:any):Promise<number> {
    let endpoint = `${this.baseUrl}/session`;
    let result = await firstValueFrom(this.http.post<number>(endpoint, createSessionRequest));
    return result;
  }

  async searchSessions(username:string):Promise<Array<SessionInfo>> {
    let endpoint = `${this.baseUrl}/sessions`;
    let args = { username: username };
    let result = await firstValueFrom(this.http.post<Array<SessionInfo>>(endpoint, args));
    return result;
  }

  async getSession(sessionId:number):Promise<Session|null> {
    let loggedInUser = this.authenticationService.getLoggedInUsername();
    let endpoint = `${this.baseUrl}/sessionbyid/${sessionId}`;
    const headers = new HttpHeaders({ 'username': loggedInUser });
    try {
      let result = await firstValueFrom(this.http.get<Session>(endpoint, { headers }));
      return result;
    }
    catch(error) {
      console.error(error);
      return null;
    }
  }

  async getUploadUrl(key:string, contentType:string):Promise<string> {
    let endpoint = `${this.baseUrl}/presignedurl`;
    let args = { key: key, contentType: contentType }
    let result = await firstValueFrom(this.http.post<string>(endpoint, args));
    return result;
  }

  async insertSwing(request:NewSwingRequest):Promise<boolean> {
    let endpoint = `${this.baseUrl}/swing`;
    let result = await firstValueFrom(this.http.post<boolean>(endpoint, request));
    return result;
  }

  async searchSwings(sessionId:number):Promise<Array<Swing>> {
    let endpoint = `${this.baseUrl}/swings`;
    let args = { sessionId: sessionId };
    let result = await firstValueFrom(this.http.post<Array<Swing>>(endpoint, args));
    return result;
  }

  async saveSwingNote(swingId:string, notes:string):Promise<boolean> {
    let endpoint = `${this.baseUrl}/swingnote`;
    let args = { swingId: swingId, notes: notes };
    let result = await firstValueFrom(this.http.patch<boolean>(endpoint, args));
    return result;
  }

  async saveSwingTag(swingId:string, tag:string):Promise<boolean> {
    let endpoint = `${this.baseUrl}/swingtag`;
    let args = { swingId: swingId, tag: tag };
    let result = await firstValueFrom(this.http.patch<boolean>(endpoint, args));
    return result;
  }

  async removeSwingTag(swingId:string, tag:string):Promise<boolean> {
    let endpoint = `${this.baseUrl}/swingtag`;
    let args = { swingId: swingId, tag: tag };
    let result = await firstValueFrom(this.http.request<boolean>('DELETE', endpoint, { body: args }));
    return result;
  }

  getSuppportedShotData():ShotData {
    let result = {
      "club": { label: "Club Used", value: null },
      "ballSpeed": { label: "Ball Speed", value: null },
      "clubSpeed": { label: "Club Head Speed", value: null},
      "totalSpin": { label: "Total Spin", value: null },
      "carryDistance": { label: "Carry Dist.", value: null }
    }

    return result;
  }

  async saveShotData(swingId:string, data:ShotData):Promise<boolean> {
    let endpoint = `${this.baseUrl}/shotdata`;
    let args = { swingId: swingId, shotData: data };
    let result = await firstValueFrom(this.http.patch<boolean>(endpoint, args));
    return result;
  }
}